import { TemplateEngine } from "../../../../../js/lib/TemplateEngine";
import { BaseResultsView } from "./BaseResultsView";

export class WorldBookresultsView extends BaseResultsView {
  constructor(options) {
    super($.extend(true, {}, options));
    this.resources;
  }
  loadResults(event, onChangeViewEvent) {
    var _this = this;
    this.resources = event.data.resources;

    if (event.success) {
      TemplateEngine.fetch(
        "tmpl/results/thirdParty/worldBookResults.html",
        $("#" + _this.resultsId),
        _this.resources,
        function () {},
        TemplateEngine.method.overwrite
      );
    } else {
      $("#" + this.resultsId).empty();
    }
  }
}
